import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
export class CfAlertsService {

  onAlertInfo: Subject<string> = new Subject<string>();

  onAlertOk: Subject<string> = new Subject<string>();

  onAlertCancel: Subject<string> = new Subject<string>();
/**
 * @param {?} id
 * @return {?}
 */
alertInfoEvent(id: any) { this.onAlertInfo.next(id); }
/**
 * @param {?} id
 * @return {?}
 */
alertOkEvent(id: any) { this.onAlertOk.next(id); }
/**
 * @param {?} id
 * @return {?}
 */
alertCancelEvent(id: any) { this.onAlertCancel.next(id); }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAlertsService_tsickle_Closure_declarations() {
/** @type {?} */
CfAlertsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAlertsService.ctorParameters;
/** @type {?} */
CfAlertsService.prototype.onAlertInfo;
/** @type {?} */
CfAlertsService.prototype.onAlertOk;
/** @type {?} */
CfAlertsService.prototype.onAlertCancel;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
